import "../../../chunk-D57E6H3M.mjs";

// src/components/composite/ChatMarkdown/context.ts
import * as React from "react";
var ChatMarkdownContext = React.createContext({});
export {
  ChatMarkdownContext
};
//# sourceMappingURL=context.mjs.map